import { queryKey } from 'Shared/const/queryKey';
import { useSDQuery } from 'viewup-lib/react';
import type { GetViewingTypeInfoRes } from '../../api/mapper/getViewingTypeInfo';
import type { ViewingCommonQueryKey } from '../../api/queries';

export const useGetRewardPointMap = () => {
  const queryResult = useSDQuery<
    GetViewingTypeInfoRes,
    unknown,
    ReturnType<typeof rewardPointMap>,
    ViewingCommonQueryKey['rewards']['queryKey']
  >({
    ...queryKey.viewingCommon.rewards,
    gcTime: 1000 * 60 * 5,
    select(data) {
      return rewardPointMap(data);
    },
    staleTime: 1000 * 60 * 5,
  });

  return queryResult;
};

const rewardPointMap = (res: GetViewingTypeInfoRes) => {
  const points = Object.entries(res);
  const click = points
    .filter(([typeCode]) => typeCode.startsWith('click'))
    .map(([, { point }]) => point);

  const macro = points
    .filter(
      ([typeCode]) =>
        typeCode.startsWith('click') &&
        !typeCode.includes('youtube') &&
        !typeCode.includes('facebook-comment') &&
        !typeCode.includes('thread-comment'),
    )
    .map(([, { point }]) => point);

  const off = points
    .filter(([typeCode]) => typeCode.startsWith('auto') || typeCode.startsWith('plus'))
    .map(([, { point }]) => point);

  const post = points
    .filter(([typeCode]) => typeCode.startsWith('post'))
    .map(([, { point }]) => point);

  const pointMap = {
    auto: {
      max: Math.max(...off).toLocaleString('ko-KR'),
      min: Math.min(...off).toLocaleString('ko-KR'),
    },
    click: {
      max: Math.max(...click).toLocaleString('ko-KR'),
      min: Math.min(...click).toLocaleString('ko-KR'),
    },
    macro: {
      max: Math.max(...macro).toLocaleString('ko-KR'),
      min: Math.min(...macro).toLocaleString('ko-KR'),
    },
    post: {
      max: Math.max(...post).toLocaleString('ko-KR'),
      min: Math.min(...post).toLocaleString('ko-KR'),
    },
  };

  return pointMap;
};
